<template>
    <div class="featured-destinations">

        <div class="container-fluid">

            <h2 class="title">Explore Destinations</h2>

            <div class="destinations">

                <div class="row" v-for="chunk in destinationsChunks">

                    <div class="col-md-6" v-for="city in chunk" :key="city.description">

                        <div class="destination">
                            <div class="discover">Discover</div>

                            <div class="city-title" >
                                <h2 :style="{ backgroundImage: `url(${city.featured_image})` }" v-text="city.title"></h2>
                            </div>

                            <div class="body" v-html="city.body"></div>

                            <a class="btn-circle" :href="city.url">
                                <svg class="arrow-right"><use xlink:href="#arrow-right-2"></use></svg>
                            </a>
                        </div>

                    </div>

                </div>

            </div>

            <div class="destinations-carousel">

                <div id="destinations-slider">

                    <div v-for="city in destinations" :key="city.description">

                        <div class="destination">
                            <div class="discover">Discover</div>

                            <div class="city-title" >
                                <h2 :style="{ backgroundImage: `url(${city.featured_image})` }" v-text="city.title"></h2>
                            </div>

                            <div class="body" v-html="city.body"></div>

                            <a class="btn-circle" :href="city.url">
                                <svg class="arrow-right"><use xlink:href="#arrow-right-2"></use></svg>
                            </a>
                        </div>

                    </div>

                </div>

            </div>

            <a class="btn-destinations" href="/destinations">
                View all Destinations
            </a>

        </div>

    </div>
</template>
<script>

export default {

    props: ['destinations'],

    data() {
        return {
            destinationsChunks: [],
        }
    },

    created() {
        this.destinationsChunks = _.chunk(this.destinations, 2)
    },

    mounted() {
        this.$nextTick(() => {
            $('#destinations-slider').slick({
                infinite: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                autoplay: true,
                dots: true,
            })
        })
    }
}
</script>
